import flatpickr from 'flatpickr';

const datePicker = (selector, options) => {
    flatpickr(selector, options);
};

export default datePicker;
